const localData = localStorage.getItem('navSettings') || '{}';
const localProfile = localStorage.getItem('smartFeedBackData') || '{}';
// console.log('localData', localData);

const initialState = {
	navBarExpanded: false,
	campaignDetails: {},
	user: {},
	company: null,
	name: localProfile ? JSON.parse(localProfile).name : localData ? JSON.parse(localData).name : null,
	logoUrl: localProfile ? JSON.parse(localProfile).logoUrl : localData ? JSON.parse(localData).logoUrl : null,
};

const appReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_USER':
			return {
				...state,
				user: action.payload,
			};
		case 'SET_NAVBAR':
			return {
				...state,
				navBarExpanded: action.payload,
			};

		case 'SET_CAMPAIGN':
			return {
				...state,
				campaignDetails: action.payload,
			};
		case 'SET_COMPANY':
			return {
				...state,
				company: action.payload,
			};
		case 'SET_PROFILE':
			return {
				...state,
				name: action.payload.name,
				logoUrl: action.payload.logoUrl,
			};

		
		default:
			return state;
	}
};

export default appReducer;
